module.exports = __webpack_public_path__ + "img/图片7.1141ad8c.png";